import { ChevronDown, ChevronUp } from "lucide-react";
import { TableHead } from "../../../../components/ui/table";
import { cn } from "../../../../lib/utils";

interface SortableTableHeadProps {
	sorted: false | "asc" | "desc";
	onToggle?: (event: unknown) => void;
	alignRight?: boolean;
	className?: string;
	children?: React.ReactNode;
}

export const SortableTableHead: React.FC<SortableTableHeadProps> = ({
	sorted,
	onToggle,
	alignRight = false,
	className,
	children,
}) => (
	<TableHead
		className={cn(
			"whitespace-nowrap px-2 py-3",
			alignRight && "text-right",
			className
		)}
		aria-sort={
			sorted === "asc"
				? "ascending"
				: sorted === "desc"
					? "descending"
					: undefined
		}
	>
		<div
			className={cn(
				"flex items-center gap-2",
				alignRight && "justify-end",
				onToggle && "cursor-pointer select-none"
			)}
			onClick={onToggle}
		>
			{children}
			{onToggle && (
				<div className="flex flex-col">
					{sorted === "asc" && <ChevronUp className="h-3 w-3" />}
					{sorted === "desc" && <ChevronDown className="h-3 w-3" />}
					{!sorted && (
						<div className="h-3 w-3 opacity-50">
							<ChevronUp className="h-2 w-2" />
							<ChevronDown className="-mt-1 h-2 w-2" />
						</div>
					)}
				</div>
			)}
		</div>
	</TableHead>
);
